module.exports = __webpack_public_path__ + "static/media/timelapse_24.348020b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_24.jpg
// module id = 982
// module chunks = 0